import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const JOBACCESS45MINUTETRANSITDIFFINVANY_LAYER_ID =
  'jobAccess45MinuteTransitDiffInvAnyLayer';

const layerConfig = {
  title: 'Job Access 45 Minute Transit Diff',
};

function JobAccess45MinuteTransitDiffInvAnyLayer() {
  const dispatch = useDispatch();
  const { jobAccess45MinuteTransitDiffInvAnyLayer } = useSelector(
    (state) => state.carto.layers
  );
  const source = useSelector((state) =>
    selectSourceById(state, jobAccess45MinuteTransitDiffInvAnyLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (jobAccess45MinuteTransitDiffInvAnyLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: JOBACCESS45MINUTETRANSITDIFFINVANY_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: jobAccess45MinuteTransitDiffInvAnyLayer.visible,
      opacity: jobAccess45MinuteTransitDiffInvAnyLayer.opacity,
      getFillColor: colorBins({
        attr: 'job_access_45minute_transit_diff',
        domain: [-47154, -20154.658, -12102.78, -4907.306, 4963.342, 62601.095, 700674],
        colors: [
          [178, 34, 34],
          [255, 0, 0],
          [255, 102, 102],
          [255, 153, 153],
          [255, 204, 204],
          [153, 204, 255],
          [51, 102, 255],
          [0, 0, 128],
        ],
      }),
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: JOBACCESS45MINUTETRANSITDIFFINVANY_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['job_access_45minute_transit_diff', 'geo_level_id'],
            }),
          };
        }
      },
    });
  }
}

export default JobAccess45MinuteTransitDiffInvAnyLayer;
